import {SYSTEM } from '../constants';

import { updateObject } from '../utils/utility';

const initialState = {
	    isLoading: true,
	    isFail: true,
	    result: {
            pagination: {
                totlal: 0,
                pageSize: 10,
                pageNumber: 1
            },
            resultList:[]
        }
	}

const systemReducer = (state = initialState, action) => {
    switch(action.type) {
        case SYSTEM.GROUP_QUERY: return groupQuery(state, action);
        case SYSTEM.QUERY_SUCCESS: return queryGroupSuccess(state, action);
        case SYSTEM.QUERY_LOAD: return queryLoad(state, action);
        
        default: return state;
    }
}


const queryLoad = (state, action) => {
    return updateObject(state, {isLoading: true, isFail: false});
}
const groupQuery = (state, action) => {
    return updateObject(state, {isLoading: true});
}

const queryGroupSuccess = (state, action) => {
    return updateObject(state, {
        isLoading: false,
        isFail: false,
        result: action.result
    });
}

export default systemReducer;